import { Controller } from "@hotwired/stimulus";

// Reveals an optional field. When off, its inputs are disabled (omitted from the
// submission) except reset sentinels marked data-reveal-switch-keep, which keep
// submitting a blank so the model clears the value. An optional `field` target
// lets the switch also drive a real boolean (e.g. is_bundle).
export default class extends Controller {
  static targets = ["toggle", "content", "field"];

  connect() {
    this.#apply(this.#on);
  }

  toggle() {
    const on = !this.#on;
    this.#apply(on);
    if (!on) return;

    // Seed an empty field with its default so the switch persists a value
    // even if the organiser doesn't type one (e.g. the reconfirmation limit).
    this.#visibleInputs.forEach((input) => {
      if (!input.value && input.dataset.revealSwitchDefault) {
        input.value = input.dataset.revealSwitchDefault;
      }
    });
    this.#visibleInputs[0]?.focus();
  }

  #apply(on) {
    this.toggleTarget.classList.toggle("on", on);
    this.contentTarget.hidden = !on;
    this.#inputs.forEach((input) => (input.disabled = !on));
    if (this.hasFieldTarget) this.fieldTarget.checked = on;
  }

  get #on() {
    return this.toggleTarget.classList.contains("on");
  }

  get #inputs() {
    return this.contentTarget.querySelectorAll(
      "input:not([data-reveal-switch-keep]), select, textarea",
    );
  }

  get #visibleInputs() {
    return this.contentTarget.querySelectorAll(
      "input:not([type=hidden]), select, textarea",
    );
  }
}
